import api from "@/router/api"

export default {
    getAllLevels3({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel3.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_LEVELS_3', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los niveles 3',
                })
            })
        })
    },
}
